import React, { createContext, useCallback, useContext, useState } from 'react';
import { Container } from 'react-bootstrap';
import { TIPO_USUARIO } from '../utils/funcoes';
import { User } from '../hooks/auth';

type IPermission = {
  children: React.ReactNode;
  permissions: string[];
};

function PegaTipo(tipo: number): string[] {
  if (tipo === TIPO_USUARIO.ADMINISTRADOR)
    return ['ATENDENTE', 'CAIXA', 'COBRANCA', 'GERENTE', 'ADMIN'];
  if (tipo === TIPO_USUARIO.SUPERVISOR)
    return ['ATENDENTE', 'CAIXA', 'COBRANCA', 'GERENTE'];
  if (tipo === TIPO_USUARIO.COBRANCA) return ['ATENDENTE', 'CAIXA', 'COBRANCA'];
  if (tipo === TIPO_USUARIO.ATENDENTE_CAIXA) return ['ATENDENTE', 'CAIXA'];

  return ['ATENDENTE'];
}

const useGetUserPermissions = (): string[] => {
  const user = localStorage.getItem('@AgendaFacil:user');
  console.log(user);
  const userObj: User = JSON.parse(
    user || '{ "UsuPermissao": "TESTE", "UsuTipo": 0 }',
  );

  const permissoes = userObj.UsuPermissao?.split(',') || ['teste'];
  const tipo = PegaTipo(userObj.UsuTipo);

  return [...permissoes, ...tipo];
};

const PermissionProvider: React.FC<IPermission> = ({
  children,
  permissions,
}) => {
  const userPermissions = useGetUserPermissions();
  if (
    permissions.some(permission => {
      return userPermissions.includes(permission);
    })
  ) {
    return <>{children}</>;
  }
  return (
    <Container fluid className="mt-2">
      <div
        className="bg-white border p-2 mb-2"
        style={{ minHeight: '400px', alignContent: 'center' }}
      >
        <h2 style={{ textAlign: 'center' }}>Acesso não permitido</h2>
      </div>
    </Container>
  );
};
export { PermissionProvider, useGetUserPermissions };
